"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('view', function (frameId) {
    this.frameId = frameId; // Has to be passed
    this.get = function ( /* data */) {
        namespace_1.default.debug.showError(this.frameId + ': .get has to be extended in this view.');
    };
});
